import { render, staticRenderFns } from "./PolymorphicReferenceShow.vue?vue&type=template&id=23910436&"
import script from "./PolymorphicReferenceShow.vue?vue&type=script&lang=js&"
export * from "./PolymorphicReferenceShow.vue?vue&type=script&lang=js&"
import style0 from "./PolymorphicReferenceShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports